const PDF_VIEW = '#page=1&toolbar=0&navpanes=0&scrollbar=0&view=Fit';

function isPrairiStorageHost(hostname: string): boolean {
  return (
    hostname === 'firebasestorage.googleapis.com' ||
    hostname === 'storage.googleapis.com' ||
    hostname.endsWith('.firebasestorage.app')
  );
}

/** Admin iframes load Prairi decks through the same proxy as the profile viewer. */
export function pitchDeckFrameSrc(url: string): string {
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'https:' && isPrairiStorageHost(parsed.hostname)) {
      return `/__pitchdeck?url=${encodeURIComponent(url)}${PDF_VIEW}`;
    }
  } catch {
    return url;
  }
  return `${url}${PDF_VIEW}`;
}
